import Component from '@bythepixel/component-loader';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

function formatAsInt(value) {
  const onlyDigits = String(value).replace('$', '').replace(',', '');
  return parseInt(onlyDigits, 10);
}

export default class DualRange extends Component {
  static selector = '[data-comp-dual-range]';
  static loaderPriority = 'in-view';

  constructor(element) {
    super(element);

    this.slider = this.$container.querySelector(
      '[data-comp-dual-range-controls]',
    );

    this.uom = this.$container.dataset.uom;
    this.name = this.$container.dataset.compDualRange;

    this.minRange = this.$container.querySelector(
      '[data-dual-range-min-handle]',
    );
    this.maxRange = this.$container.querySelector(
      '[data-dual-range-max-handle]',
    );
    this.minInput = this.$container.querySelector(
      '[data-dual-range-min-input]',
    );
    this.maxInput = this.$container.querySelector(
      '[data-dual-range-max-input]',
    );
    this.minValue = this.minRange.value;
    this.maxValue = this.maxRange.value;
    this.stepValue = this.maxRange.step;

    this.initSlider();

    this.attachEventListenersToInput(this.minInput);
    this.attachEventListenersToInput(this.maxInput);
    this.pageLoadEvents();

    window.addEventListener(`resetRange${this.name}Min`, () => {
      this.minInput.value = this.formatForInput(this.minRange.min);
      this.updateSliderValues();
    });

    window.addEventListener(`resetRange${this.name}Max`, () => {
      this.maxInput.value = this.formatForInput(this.maxRange.max, true);
      this.updateSliderValues();
    });
  }

  initSlider() {
    const min = Number(this.minRange.min);
    const max = Number(this.maxRange.max);
    const minValue = Number(this.minValue);
    const maxValue = Number(this.maxValue);
    const stepValue = Number(this.stepValue);

    noUiSlider.create(this.slider, {
      start: [minValue, maxValue],
      connect: true,
      step: stepValue,
      range: {
        min,
        max,
      },
    });

    this.slider.noUiSlider.on('update', (values, handle) => {
      const value = values[handle];
      // handle is either 0 or 1 because we only have two handles
      if (handle === 1) {
        this.maxInput.value = this.formatForInput(value, true);
        this.maxRange.value = formatAsInt(value);
        this.maxRange.dispatchEvent(new Event('input'));
      } else {
        this.minInput.value = this.formatForInput(value);
        this.minRange.value = formatAsInt(value);
        this.minRange.dispatchEvent(new Event('input'));
      }
    });
  }

  pageLoadEvents() {
    if (!this.minRange || !this.maxRange) {
      return;
    }

    this.maxInput.value = this.formatForInput(this.maxRange.value, true);
    this.minInput.value = this.formatForInput(this.minRange.value);
    this.updateSliderValues();
  }

  updateSliderValues() {
    const [min, max] = [
      formatAsInt(this.minInput.value),
      formatAsInt(this.maxInput.value),
    ];
    this.slider.noUiSlider.set([min, max]);
  }

  /**
   * @param {HTMLElement} inputElement
   * @returns
   */
  attachEventListenersToInput(inputElement) {
    if (!this.minInput || !this.maxInput || !this.maxRange) {
      return;
    }

    // when focus on input, clear it but don't update slider until blur
    inputElement.addEventListener('focus', () => {
      // eslint-disable-next-line
      inputElement.value = "";
    });

    inputElement.addEventListener('blur', () => {
      this.updateSliderValues();
    });

    inputElement.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        this.updateSliderValues();
      }
    });
  }

  formatForInput(value, isMaxRangeHandle = false) {
    let formatted = formatAsInt(value);

    if (!this.uom) {
      return formatted;
    }

    formatted = formatted.toLocaleString('en-US');

    if (this.uom === 'usd') {
      if (isMaxRangeHandle) {
        return parseInt(this.maxRange.max) === parseInt(value)
          ? `$${formatted}+`
          : `$${formatted}`;
      }

      return `$${formatted}`;
    }

    if (isMaxRangeHandle) {
      return parseInt(this.maxRange.max) === parseInt(value)
        ? `${formatted}+ ${this.uom}`
        : `${formatted} ${this.uom}`;
    }

    return `${formatted} ${this.uom}`;
  }
}
